/**
 * Resolve a product/asset image URL.
 * - Absolute URLs (http/https) are returned as-is.
 * - Relative paths starting with /api are prefixed with the backend URL.
 * - Falsy/missing values return null so the caller can render a placeholder.
 *
 * @param url raw url stored in DB
 * @param size optional pixel size for the longest edge (400 for cards, 800 for detail)
 */
export const resolveImageUrl = (url, size = null) => {
  if (!url) return null;
  if (typeof url !== 'string') return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) {
    const base = `${process.env.REACT_APP_BACKEND_URL}${url}`;
    if (size && url.includes('/api/files/')) {
      return `${base}${base.includes('?') ? '&' : '?'}size=${size}`;
    }
    return base;
  }
  return url;
};
